(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

var insuranceType;
$(window).on('load', function () {
  insuranceType = window.insuranceType.toLowerCase(); // This object is to map the insuranceType, passed in through the route,
  // to a select option from the free quote form.

  var validChoicesMap = {
    auto: 'AU',
    renters: 'RE',
    motorcycle: 'MO',
    boat: 'BO',
    motorHome: 'MH',
    travelTrailer: 'TT',
    commercial: 'CA',
    homeowners: 'HO',
    life: 'LI',
    health: 'HE',
    pet: 'PI'
  };

  if (insuranceType && Object.keys(validChoicesMap).includes(insuranceType)) {
    var insuranceProductCode = validChoicesMap[insuranceType];
    $(function () {
      // The hidden input is used for triggering the corresponding redirect modal when the hero free quote form is submitted.
      // (See freeQuote_refresh.js)
      $('#insurance-product-code').val(insuranceProductCode); // Removes the carousel div and subnav dropdown choice
      // that corresponds to the insurance type of current page.

      $(".".concat(insuranceType)).remove();
      $('#insurance-products-carousel-indicator').children().last().remove(); // Sets the form action of the hero free quote form

      $('.hero .free-quote').attr('action', getHeroFormAction(insuranceProductCode)); // Sets the default value of the .get-quote-module selects

      $('.get-quote-module .free-quote select').val(insuranceProductCode);
      $('.get-quote-module .free-quote select').trigger('change');
      $('.free-quote').attr('target', '_blank');
      /**
       * Sets the intitial form action of the hero free quote form for insurance product pages.
       * @param {String} insuranceProductCode
       * @returns {String} - The corresponding form action for the insurance product code.
       */

      function getHeroFormAction(insuranceProductCode) {
        var formAction;

        switch (insuranceProductCode) {
          case 'AU':
            formAction = '/TGRV2/EntryGateway.gen';
            break;

          case 'MO':
            formAction = 'https://www.dairylandinsurance.com/?action=StartQuote&zip=&product=motorcycle&utm_source=TheGeneral&utm_medium=cpc&AOE=1214661';
            break;

          case 'CA':
            formAction = 'https://www.progressivecommercial.com/lp/thegeneral/?zipCode=';
            break;

          default:
            formAction = '/TGRV2/EntryGateway.gen';
            break;
        }

        return formAction;
      }
    });
  }

  $(function () {
    var insuranceProductsSubnav = $('#insurance-products-subnav');

    if (insuranceProductsSubnav.length) {
      var lastScrollTop = 0; // Sticky subnav effect

      $(window).on('scroll', function () {
        var currentScrollTop = $(window).scrollTop();
        var callOutSection = $('#call-out-section'); // Sets a higher z-index to the subnav as the window approaches just above the subnav,
        // or removes it when it's well above the subnav

        if (currentScrollTop >= callOutSection.offset().top - 200) {
          if (!insuranceProductsSubnav.hasClass('tertiary-nav-zindex')) {
            insuranceProductsSubnav.addClass('tertiary-nav-zindex');
          }
        } else {
          if (insuranceProductsSubnav.hasClass('tertiary-nav-zindex')) {
            insuranceProductsSubnav.removeClass('tertiary-nav-zindex');
          }
        } // This if-else detects if the window is scrolling down or not.
        // If scrolling down and the window is below callOutSection, fix subnav to top.
        // If scrolling and window is above, remove the 'position: fix' from subnav.


        if (currentScrollTop > lastScrollTop) {
          if (currentScrollTop > callOutSection.offset().top) {
            if (!insuranceProductsSubnav.hasClass('tertiary-nav-fixed')) {
              insuranceProductsSubnav.addClass('tertiary-nav-fixed');
            }
          }
        } else {
          if (currentScrollTop <= callOutSection.offset().top) {
            if (insuranceProductsSubnav.hasClass('tertiary-nav-fixed')) {
              insuranceProductsSubnav.removeClass('tertiary-nav-fixed');
            }
          }
        } // These block is outside the if-else scrolling detection block because the code needs to run
        // regardless of whether user is scrolling up or down.


        if (currentScrollTop > callOutSection.offset().top) {
          // "Pushes" the main nav up partially off-screen when window is below callOutSection
          $('.main-nav').css('top', -$('.primary-nav').height() + 'px');
        } else {
          if ($(window).scrollTop() < callOutSection.offset().top && $(window).scrollTop() > callOutSection.offset().top - $('.primary-nav').height()) {
            // Creates the effect of the subnav pushing the primary-nav up when they make contact
            $('.main-nav').css('top', -($(window).scrollTop() - (callOutSection.offset().top - $('.primary-nav').height())) + 'px');
          } else {
            $('.main-nav').css('top', '');
          }
        }

        lastScrollTop = currentScrollTop;
      });
    }
  });
});

},{}]},{},[1]);
